<template>
    <div>
        <my-form v-model="form" class="form-page" readonly table>
            <my-form-item-group title="工单详情">
                <el-form-item label="主题" prop="title" class="table-full-row">
                    {{form.title||'-'}}
                </el-form-item>
                <el-form-item label="手机" prop="phone">
                    {{form.phone}}
                </el-form-item>
                <el-form-item label="邮箱" prop="email">
                    {{form.email||'-'}}
                </el-form-item>
                <el-form-item label="内容" prop="detail" class="table-full-row">
                    {{form.detail||'-'}}
                </el-form-item>
                <el-form-item label="招标项目名称">
                    {{form.zbproname||'-'}}
                </el-form-item>
                <el-form-item label="招标项目编号" prop="zbprocode">
                    {{form.zbprocode||'-'}}
                </el-form-item>
                <el-form-item label="附件" class="table-full-row">
                    <my-upload readonly  :file-guid="fileguid">
                        
                    </my-upload>
                </el-form-item>
            </my-form-item-group>
        </my-form>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
export default {
    mixins: [LIST_PAGE_MIXIN],
    data() {
        return{
            fileguid:'',
            form:{}
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {


    },
    created() {
        
    },
    mounted() {
        var that=this;
        if(this.$route.query.id!=undefined){
            that.$get(`${this.getGetters('mngUrl')}/manage/business/xgsq/detail.json`,{id:this.$route.query.id}, (data, res) => {
                that.form=data.model;
                console.log(that.form)
                that.fileguid=data.model.fileguid;
            });
        }
    }
}
</script>

<style scoped lang="scss">

</style>
